import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
      },
      icon: {
        width: 104,
        height: 104,
        color: sicrediColor.primarySicredi,
      },
      textBox: {
        marginLeft: theme.spacing(5),
        color: sicrediColor.secondarySicrediDarker,
      },
      title: {
        fontFamily: '"Exo 2", sans-serif',
        fontWeight: 300,
        fontSize: 32,
        lineHeight: '52px',
        marginBottom: theme.spacing(6),
      },
      message: {
        fontWeight: 300,
        fontSize: 18,
        lineHeight: '24px',
        whiteSpace: 'pre-line',
        '& strong': {
          fontWeight: 600,
        },
      },
    }),
  { name: 'Manutencao' }
);
